import axios from 'axios'

// 创建 axios 实例
const request = axios.create({
  baseURL: '/',
  timeout: 12000, // 请求超时时间
});
// 添加响应拦截器
request.interceptors.response.use(
  (response) => {
    return response.data;
  }, 
  (error) => {
    console.error(error);
  }
);

//公用头部
request.defaults.headers.common["token"] = window.localStorage.getItem("token");
request.defaults.timeout = 60000;

export default request;